<template>
	<div class="dialog-wrap">
		<el-dialog :title="''" :visible.sync="centerDialogVisible" :show-close="showClose" @close="onDialogClose"
			:width="width" :modal="modal" center :before-close="dialogVisibleCancelClick">
			<div class="flex">
				<i class="el-icon-warning"></i>
				<div class="title">您确定要<span style="color: #ff0000;">{{titleType}}</span>{{title}}</div>
			</div>
			<slot class="dialog-body-wrap"></slot>
			<span slot="footer" class="dialog-footer" v-if="showBtns">
				<el-button @click="dialogVisibleCancelClick">{{cancelBtnText}}</el-button>
				<el-button type="primary" @click="dialogConfirmClick">{{confirmBtnText}}</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-else>
				<el-button type="primary" @click="dialogVisibleCancelClick">{{cancelBtnText}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'commonpagination',
		props: {
			title: {
				required: false,
			},
			titleType: {
				required: false,
			},
			dialogVisible: {
				required: true,
				default: false
			},
			showClose: {
				default: false
			},
			showBtns: {
				type: Boolean,
				default: true
			},
			cancelBtnText: {
				default: '取消',
			},
			confirmBtnText: {
				default: '确定'
			},
			width: {
				default: '25%'
			},
			modal: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				centerDialogVisible: this.dialogVisible
			};
		},
		computed: {},
		mounted() {

		},
		methods: {
			dialogConfirmClick() {
				this.$emit('confirm')
			},
			dialogVisibleCancelClick() {
				this.centerDialogVisible = false
				// this.$emit('cancel')
			},
			onDialogClose() {
				this.$emit('dialog-close')
			}
		},
		watch: {
			dialogVisible(val) {
				this.centerDialogVisible = val;
			}
		}
	}
</script>

<style lang="less" scoped>
	.el-icon-warning{
		font-size: 18px;
		color: #faad14;
	}
	.title{
		margin-left: 10px;
		font-size: 16px;
		font-weight: 500;
	}
	/deep/ .el-dialog--center{
		text-align: right;
	}
</style>
